export default "__VITE_ASSET__u72MSCAj__"